import { render, staticRenderFns } from "./LegRow.vue?vue&type=template&id=656f69aa&scoped=true"
import script from "./LegRow.vue?vue&type=script&lang=js"
export * from "./LegRow.vue?vue&type=script&lang=js"
import style0 from "./LegRow.vue?vue&type=style&index=0&id=656f69aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f69aa",
  null
  
)

export default component.exports